import React from 'react';
import Home from './components/Home';
import Profile from './components/Profile';
import Contact from './components/Contact';
import Project from './components/Project';

import IndonesianHome from './components/Indonesian/Home';
import IndonesianProfile from './components/Indonesian/Profile';
import IndonesianContact from './components/Indonesian/Contact';
import IndonesianProject from './components/Indonesian/Project';
import IndonesianCareerIndex from './components/Indonesian/Career/Index';
import IndonesianCareerShow from './components/Indonesian/Career/Show';

import EnglishHome from './components/English/Home';
import EnglishProfile from './components/English/Profile';
import EnglishContact from './components/English/Contact';
import EnglishProject from './components/English/Project';
import EnglishCareerIndex from './components/English/Career/Index';
import EnglishCareerShow from './components/English/Career/Show';

const pack = (Component) => {
    return (props) => (<Component {...props}/>);    
}

export default[
    {path: "/", componentEnglish : pack(EnglishHome), componentIndonesian : pack(IndonesianHome)},
    {path: "/profile", componentEnglish : pack(EnglishProfile), componentIndonesian : pack(IndonesianProfile)},
    {path: "/projects", componentEnglish : pack(EnglishProject), componentIndonesian : pack(IndonesianProject)},
    {path: "/contact", componentEnglish : pack(EnglishContact), componentIndonesian : pack(IndonesianContact)},
    {path: "/careers", componentEnglish : pack(EnglishCareerIndex), componentIndonesian : pack(IndonesianCareerIndex)},
    {path: "/careers/:id", componentEnglish : pack(EnglishCareerShow), componentIndonesian : pack(IndonesianCareerShow)},
    // {path: "/profile",component : pack(Profile)},
    // {path: "/projects",component : pack(Project)},
    // {path: "/contact",component : pack(Contact)},
];
